module.exports = __webpack_public_path__ + "static/media/img2-1.7368d52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/N/img2-1.png
// module id = 1291
// module chunks = 3